/**
 * Resolve a poster/banner/media path into a URL the browser can load.
 *
 * - Absolute URLs (http/https) are returned unchanged so browsers fetch them
 *   directly (works for TMDB CDN, Picsum, any external image host — no auth,
 *   no proxy hop, no CORS surprises).
 * - Relative paths are proxied through `${API}/files/${path}` so cookies-based
 *   auth still applies and R2-hosted files get their signed-URL redirect.
 *
 * Usage:
 *   import { mediaUrl } from '../utils/mediaUrl';
 *   <img src={mediaUrl(movie.poster_path, API)} />
 *
 * Note: `API` is passed in explicitly rather than imported from a central
 * config to keep this util decoupled from the app's env layer.
 */
export function mediaUrl(path, api) {
  if (!path) return null;
  if (typeof path !== 'string') return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Encode individual segments so `#` / `?` in a filename don't split the URL,
  // but leave `/` untouched so the path structure is preserved.
  const encoded = path.split('/').map(encodeURIComponent).join('/');
  return `${api}/files/${encoded}`;
}
